/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 // 2022/3/21 Add Start Add cart on product page
  var Shopify = Shopify || {};
  // ---------------------------------------------------------------------------
  // Money format handler Start
  // ---------------------------------------------------------------------------
  Shopify.money_format = "${{amount}}";
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
  // ---------------------------------------------------------------------------
  // Money format handler End
  // ---------------------------------------------------------------------------

  
  //Render Cart item list
  const rerenderPage = (_variant_id,_action)=>{
    //location.reload();
    window.fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
  })
    .then((response) => response.json())
    .then((cart) => {
      const variant_obj = cart.items.find((v) => v.id == _variant_id);
      if(_action ==="add"){
        //カート追加時
        const add_item_dom = document.createElement("div");
        add_item_dom.setAttribute("id", "line_item_"+_variant_id);
        add_item_dom.classList.add("CartItem");
        add_item_dom.innerHTML = `
          <div class="CartItem__Info c-CartItem__Info">
            <h2 class="CartItem__Title Heading ls2">
              <a href="${variant_obj.url}">${variant_obj.product_title}</a>
              <span class="c-Price">${Shopify.formatMoney(variant_obj.price,"¥{{amount_no_decimals}}")} <small>(税込)</small></span>
            </h2>

            <div class="CartItem__Meta Heading Text--subdued">
              <p class="CartItem__Variant">${variant_obj.variant_title}</p>
            </div>

            <div class="CartItem__Actions Heading Text--subdued" style="text-align: center">
              <div class="CartItem__QuantitySelector Rouded-Btn">
                <div class="QuantitySelector Rouded-Btn">
                  <span class="QuantitySelector__Button Link Link--primary c-Minus" title="数量を0に設定します" data-quantity="0" data-line="${variant_obj.quantity}" data-action="update-item-quantity" data-variant_id="${variant_obj.id}">
                    <svg class="Icon Icon--minus " role="presentation" viewBox="0 0 16 2">
                      <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                    </svg>
                  </span>

                  <input type="text" name="updates[]" id="updates_41632881148104:0e5589cfb46138f4cb6398a09f0f4a5f" class="QuantitySelector__CurrentQuantity" pattern="[0-9]*" data-line="${variant_obj.quantity}" value="1" data-variant_id="${variant_obj.id}">
               
                  <span class="QuantitySelector__Button Link Link--primary c-Plus" title="数量を2に設定します" data-quantity="2" data-line="${variant_obj.quantity}" data-action="update-item-quantity" data-variant_id="${variant_obj.id}">
                    <svg class="Icon Icon--plus " role="presentation" viewBox="0 0 16 16">
                      <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
                        <path d="M8,1 L8,15"></path>
                        <path d="M1,8 L15,8"></path>
                      </g>
                    </svg>
                  </span>
                </div>
              </div>
              
              <span class="CartItem__Remove Link Link--underline Link--underlineShort" data-quantity="0" data-line="${variant_obj.quantity}" data-action="remove-item" data-variant_id="${variant_obj.id}">
                <img src="https://cdn.shopify.com/s/files/1/0517/3015/3672/files/cross-svgrepo-com.svg?v=1701150262" alt="Remove" class="Icon Icon--remove" style="width: 35px">
              </span>
            </div>
          </div>`;
        add_item_dom.querySelector(".CartItem__Remove").setAttribute('onclick', `removeItem(${_variant_id})`);
        add_item_dom.querySelector(".QuantitySelector__Button.c-Minus").setAttribute('onclick', `updateItem(${_variant_id},${(variant_obj.quantity - 1)})`);
        add_item_dom.querySelector(".QuantitySelector__CurrentQuantity").setAttribute('onchange', `updateItem(${_variant_id},this.value)`);
        add_item_dom.querySelector(".QuantitySelector__Button.c-Plus").setAttribute('onclick', `updateItem(${_variant_id},${(variant_obj.quantity + 1)})`);
        document.querySelector('.c-CartItems-OnProduct').appendChild(add_item_dom);
      }else if(variant_obj === undefined || variant_obj.quantity === 0){
        //カート削除時
        document.getElementById('line_item_'+_variant_id).remove();
      }else{
        //カート更新時
        document.querySelector('#line_item_'+_variant_id+' .QuantitySelector__Button.c-Minus').setAttribute('onclick', `updateItem(${_variant_id},${(variant_obj.quantity - 1)})`);
        document.querySelector('#line_item_'+_variant_id+' .QuantitySelector__CurrentQuantity').value = variant_obj.quantity;
        document.querySelector('#line_item_'+_variant_id+' .QuantitySelector__Button.c-Plus').setAttribute('onclick', `updateItem(${_variant_id},${(variant_obj.quantity + 1)})`);
        document.querySelector('#line_item_'+_variant_id+' .c-Price').innerHTML = Shopify.formatMoney(variant_obj.final_line_price,"¥{{amount_no_decimals}}") + '<small> (税込)</small>';
      }

      document.querySelector('#c-Cart__Total-OnProduct .c-Price').innerText = Shopify.formatMoney(cart.total_price,"¥{{amount_no_decimals}}");
      document.querySelector('#c-Cart__Total-OnProduct .c-ItemCount').innerText = "("+cart.item_count+")点";
    })
  }

  //Get Cart item list
  const fetchCart = (_variant,callback)=>{
    window.fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
    })
      .then((response) => response.json())
      .then((cart) => {
        const result = cart.items.find((v) => v.id === _variant.id);
        if(result === undefined){
          if(_variant.available){
            //カート内にVariantが含まれない、かつ"add"の場合
            addItemToCart(_variant);
          }else{
            //在庫がない場合
            alert("その商品は在庫がございません。");
          }
        }
      })
      .catch((error) => {
          throw new Error(error);
      });
  }

  //Add variant to cart
  const addItemToCart =(_variant)=> {
    const formData = _variant;
    window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
    })
        .then((response) => response.json())
        .then((product) => rerenderPage(_variant.id,"add"))
        .catch((error) => {
            throw new Error(error);
        });
  }

  //Remove variant from cart
  const removeItem = (_variant_id)=> {
    const quantity = 0;
    const id = String(_variant_id);
    window.fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({quantity, id}),
      headers: {
          'Content-Type': 'application/json',
      },
    })
        .then((response) => response.json())
        .then(() => rerenderPage(_variant_id,"remove"))
        .catch((error) => {
            throw new Error(error);
        });
  }

  //Update variant from cart
  const updateItem = (_variant_id,_quantity)=> {
    const quantity = Number(_quantity);
    const id = String(_variant_id);
    window.fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({quantity, id}),
      headers: {
          'Content-Type': 'application/json',
      },
    })
        .then((response) => response.json())
        .then(() => rerenderPage(_variant_id,"update"))
        .catch((error) => {
            throw new Error(error);
        });
  }

 //Variant変更時
 document.addEventListener('variant:changed', function(event) {
    let allSelectedFlg = true;  //オプション全選択判定フラグ
    const selectedValue = document.querySelectorAll('.ProductForm__Variants .ProductForm__SelectedValue');
    selectedValue.forEach((selector)=>{
      //オプション未選択(="【必須】"を含む選択肢がある場合)
      //　フラグをfalseにし、処理中断
      if(selector.innerHTML.indexOf('【必須】') != -1){
        allSelectedFlg = false;
      }
    });

    if(allSelectedFlg){
      //オプション全選択の場合、処理を継続
      const variant = event.detail.variant; // Gives you access to the whole variant details
      fetchCart(variant);
    }
 });

 // 2022/3/21 Add End Add cart on product page

 function checkValue(checkclick){
    var btn = document.getElementById('optinbtn');
  
    if (checkclick.checked) {
        btn.value = '押せる';
        btn.removeAttribute('disabled');
    } else {
        btn.value = '押せない';
        btn.setAttribute('disabled', 'disabled');
    }
  }
  
  window.addEventListener('load', e => {
   const submitBtn = document.getElementById('optinbtn');
  
   if(submitBtn.value == "押せない"){
     submitBtn.setAttribute('disabled', 'disabled');
   }
  });
  //住所登録フォームの国項目非表示 (main-customers-addresses.liquid)
  document.addEventListener("DOMContentLoaded", function() {
      HTMLElement.prototype.trigger = function(eStr) {
        var e = document.createEvent("HTMLEvents");
        e.initEvent(eStr, true, true );
        this.dispatchEvent(e);
      }
      
      const specifyJapan = (domElement) => {
       selector_options = domElement.options;
        for(let i = 0; i < selector_options.length; i++ ){
            if(selector_options[i].value === 'Japan'){
                selector_options[i].selected = true;
                break;
            }
        }
        domElement.trigger("change");
      }
      
      //新規登録
      const new_address_country = document.getElementById('custom--address-new-country');
      if(new_address_country){specifyJapan(new_address_country);}
      //更新
      const edit_address_country = document.querySelectorAll('.custom--address-edit-country');
      if(edit_address_country){
        edit_address_country.forEach(element => specifyJapan(element));
        //初期値処理
        const edit_address_province = document.querySelectorAll('select[name="address[province]"]');
        edit_address_province.forEach(element => {
          if(element.dataset.default){
            selector_options = element.options;
            for(let i = 0; i < selector_options.length; i++ ){
                if(selector_options[i].innerText === element.dataset.default){
                    selector_options[i].selected = true;
                    break;
                }
            }
            element.trigger("change");
          }
        });
      }
  })